import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { NgxPrimengGridModule } from 'ngx-primeng-grid';
import { NgxPrimengFormModule } from 'ngx-primeng-form';

import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgxManageLayoutComponent } from './views/ngx-manage-layout/ngx-manage-layout.component';
import { NgxManageActionLayoutComponent } from './views/ngx-manage-action-layout/ngx-manage-action-layout.component';
import { NgxWrapperSharedModule } from '../ngx-wrapper-shared/ngx-wrapper.shared.module';

@NgModule({
  declarations: [NgxManageLayoutComponent, NgxManageActionLayoutComponent],
  imports: [
    CommonModule,
    FormsModule,
    ConfirmDialogModule,
    ReactiveFormsModule,
    NgxPrimengFormModule,
    NgxPrimengGridModule,
    NgxWrapperSharedModule,
    ButtonModule,
    RouterModule
  ],
  exports: [NgxManageLayoutComponent, NgxManageActionLayoutComponent]
})
export class NgxManageLayoutModule { }
